var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("SearchableDropdown", {
    staticClass: "m-b-10",
    class: _vm.customClass,
    attrs: {
      name: _vm.name,
      config: _vm.contentTypeDropdownConfig,
      clearable: false
    },
    model: {
      value: _vm.selectedContentType,
      callback: function($$v) {
        _vm.selectedContentType = $$v
      },
      expression: "selectedContentType"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }